import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import action from '../../../../actions/index';
import * as CheckVoucherComponent from './component/CommonComponent';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import i18n from "../../../../constants/initLng";
import DEFINE from "../../../../constants/Define";
import Input from '../../common/component/Input';
import { xssFilter, getLocaleFullName } from '../../../../utils/commonUtils';
import Modal from '../../common/component/Modal';
import { DATE_TIME_FORMAT, PATHS } from './../../../../constants/Define';
import * as ANT from 'antd';
import moment from 'moment'

let permisionActions = [];
let voucherPermisionActions = [];
let orderPermisionActions = [];
class Index extends Component {

    state = {
        data: {},
        usedVoucher: undefined,
        actionUsed: undefined,
        isChecked: false,
        profile: {},
        usedCount: 0,
        showPopLock: false,
        isSubmit: false,
        showPopupUse: false,
        isSubmitUse: false,
        listProperties: [],
        serialNumberState: ''
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.CHECK_VOUCHER);
        voucherPermisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.VOUCHER);
        orderPermisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ORDER);
        this.props.onResetCheck();
        this.props.onListAllProperties();
        // this.props.onListVoucher();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps && nextProps.property) {
            this.setState({
                listProperties: nextProps.property.allProperties
            })
        }
        if (nextProps && nextProps.vouchers) {
            if (nextProps.vouchers.message) {
                this.setState({
                    message: nextProps.vouchers.message,
                });
            }
        }
        if (nextProps && nextProps.vouchers) {
            this.setState({
                isChecked: nextProps.vouchers.isChecked,
                isSubmit: nextProps.vouchers.isSubmit,
                showPopLock: nextProps.vouchers.isSubmit,
                showPopupUse: nextProps.vouchers.isSubmitUse,
                isSubmitUse: nextProps.vouchers.isSubmitUse,
            });
            if (nextProps.vouchers.isUse) {
                this.setState({
                    isUse: nextProps.vouchers.isUse,
                });
            }
        }
        if (nextProps && nextProps.vouchers.resultCheck) {
            if (Object.keys(nextProps.vouchers.resultCheck).length > 0) {
                this.setState({
                    usedCount: 0,
                    resultCheck: nextProps.vouchers.resultCheck,
                });
            } else {
                this.setState({
                    resultCheck: undefined,
                });
            }
        } else {
            this.setState({
                resultCheck: undefined,
            });
        }
        // if (nextProps && nextProps.vouchers.HMSCode) {
        //     if (Object.keys(nextProps.vouchers.HMSCode).length > 0) {
        //         this.setState({
        //             resultCheck: {...this.state.resultCheck, status: 7},
        //             usedCount: (this.state.usedCount) + 1,
        //             HMSCode: nextProps.vouchers.HMSCode,
        //         });
        //     } else {
        //         this.setState({
        //             HMSCode: undefined,
        //         });
        //     }
        // }
        if (this.state.actionUsed) {
            if (nextProps && nextProps.vouchers.usedVoucher) {
                this.setState({ usedVoucher: nextProps.vouchers.usedVoucher })
            }
        }
        if (nextProps && nextProps.profile) {
            if (nextProps.profile.user) {
                this.setState({
                    profile: nextProps.profile.user,
                });
            }
        }
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        this.setState({
            data: {
                ...this.state.data,
                [params.name]: typeof params.value === 'string' ? params.value.trimLeft() : params.value,
            }
        });
    };

    onCheckVoucher = (e) => {
        e.preventDefault();
        this.setState({ serialNumberState: this.state.data.serialNumber })
        this.props.onResetCheck();
        this.setState({ usedVoucher: undefined, actionUsed: false, isChecked: false });
        this.props.onCheckVoucher(this.state);
    };

    // onUsedVoucher = (i) => {
    //     if (confirm(this.props.t('validation.sureUse'))) { //eslint-disable-line
    //         this.setState({ actionUsed: true });
    //         this.props.onUsedVoucher({
    //             ...i,
    //             serialNumber: this.state.data.serialNumber,
    //             properties: this.state.data.properties
    //         });
    //     }
    // };

    onUpdateVoucher = (i) => {
        this.props.onUpdateVoucher({ data: i, action: "CHECK" })
    };

    reloadCheck = () => {
        this.props.onResetCheck();
        this.setState({ usedVoucher: undefined, actionUsed: false, isChecked: false });
        this.props.onCheckVoucher(this.state)
    };

    onViewItem = (e) => {
        this.setState({
            showPopLock: true,
        });
    };

    onShowPopupUse = (e) => {
        this.setState({
            showPopupUse: true,
        });
    };

    onLock = () => {
        // this.props.onResetCheck();
        if (this.state.data.note) {
            this.props.onUpdateVoucher({
                data: {
                    note: this.state.data.note,
                    id: this.state.resultCheck.voucherId,
                    isLocked: !this.state.resultCheck.isLocked
                },
                reCheckVoucher: { serialNumber: this.state.data.serialNumber },
                action: "CHECK",
            });
            this.setState({
                usedVoucher: undefined,
                actionUsed: false,
                isChecked: false,
                data: { serialNumber: this.state.data.serialNumber }
            });
            // this.setState({showPopLock: false});
            this.setState({ isSubmit: true });
        } else {
            ANT.message.error('Vui lòng nhập lý do')
        }
    };

    onSubmit = () => {
        // e.preventDefault();
        const { confirm } = Modal;
        let data = this.state.data;
        if(data.checkInDate && data.checkOutDate) {
            if (data.checkInDate.isAfter(data.checkOutDate)) {
                ANT.message.error(this.props.t('validation.statusCode.code.10009'));
                return false;
            }
        }
        if (data.propertyId) {
            confirm({
                title: this.props.t(`validation.sureUse`),
                okText: this.props.t(`action.use`),
                cancelText: this.props.t(`action.cancel`),
                onOk: () => {
                    this.props.onUsedVoucher({
                        data: {
                            receiptCode: data.receiptCode,
                            checkedSystem: data.checkedSystem,
                            propertyId: data.propertyId,
                            checkInDate: data.checkInDate && (data.checkInDate).toISOString(),
                            checkOutDate: data.checkOutDate && (data.checkOutDate).toISOString(),
                            operaBookingCode: data.operaBookingCode,
                            serialNumber: data.serialNumber,
                            propertyOfStayId: data.propertyOfStayId,
                            note: data.note,
                        }, reCheckVoucher: { serialNumber: this.state.data.serialNumber }
                    });
                    this.setState({
                        receiptCode: undefined,
                        checkedSystem: false,
                        propertyId: false,
                        isChecked: false,
                        checkInDate: undefined,
                        checkOutDate: undefined,
                        operaBookingCode: undefined,
                        propertyOfStayId: undefined,
                        note: undefined,
                        data: { serialNumber: this.state.data.serialNumber }
                    });
                },
            });
            // this.setState({showPopupUse: false});
        } else {
            ANT.message.error('Vui lòng chọn địa điểm sử dụng')
        }
    };

    statusDisabled = (resultCheck) => {
        return resultCheck.status === 4 || resultCheck.status === 5 || resultCheck.isLocked
    }

    render() {
        const { t } = this.props;
        const { data, resultCheck, usedVoucher, HMSCode, isChecked, isSubmit, isUse, usedCount, profile, message, showPopLock, showPopupUse, isSubmitUse, listProperties, serialNumberState } = this.state;
        let isDisableUse = !!(resultCheck && resultCheck.voucherIssue);
        let compareUsed = resultCheck && (((resultCheck.usedCount) + usedCount) >= resultCheck.limitNumberOfTimes);
        let discountVal = "---";
        if (resultCheck) {
            switch (resultCheck.voucherType) {
                case DEFINE.GENERAL.VOUCHER_TYPE.GIFT:
                    discountVal = t(`item.group.${DEFINE.GENERAL.VOUCHER_TYPE.GIFT}`);
                    break;
                case DEFINE.GENERAL.VOUCHER_TYPE.PERCENT:
                    discountVal = `${resultCheck.discountValue}%`;
                    break;
                case DEFINE.GENERAL.VOUCHER_TYPE.MONEY:
                    discountVal = `${Func.formatMoney(resultCheck.discountValue.toString())}`;
                    break;
                default:
                    discountVal = "---";
                    break;
            }
        }
        let propertyList = [];
        if (resultCheck && profile && profile.roleId === DEFINE.GENERAL.ROLE_ID.ADMIN) {
            propertyList = resultCheck.properties;
        } else if (resultCheck && resultCheck.properties && profile && profile.propertyIds) {
            propertyList = resultCheck.properties.filter(item => profile.propertyIds.some(p => p === item.id));
        }
        return (
            <Fragment>
                <HMS.PageListComponent>
                    {
                        showPopLock && (
                            <CheckVoucherComponent.LockVoucherComponent
                                isSubmit={isSubmit}
                                showPopLock={showPopLock}
                                onClose={(i) => this.setState({ showPopLock: i })}
                                onSubmit={() => this.onLock()}
                                onChange={this.onChange}
                                data={data}
                                resultCheck={resultCheck}
                            />
                        )
                    }
                    {
                        showPopupUse && (
                            <CheckVoucherComponent.UseVoucherComponent
                                isSubmit={isSubmitUse}
                                data={data}
                                listProperty={listProperties}
                                onChange={this.onChange}
                                onClose={(i) => this.setState({
                                    showPopupUse: i,
                                    receiptCode: undefined,
                                    checkedSystem: false,
                                    propertyId: false,
                                    isChecked: false,
                                    data: { serialNumber: this.state.data.serialNumber }
                                })}
                                propertyList={propertyList}
                                onSubmitUse={this.onSubmit}
                                onSubmit={this.onSubmit}
                                showPopupUse={showPopupUse} />
                        )
                    }
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'checkVoucher'}
                    // titleHeader={t('navigation.checkVoucher')}
                    />
                    <ANT.PageHeader
                        title={t('navigation.checkVoucher')}
                    >
                        <form onSubmit={this.onCheckVoucher}>
                            <div className="w100-percent flex-center align-center jus">
                                <HMS.FormWrapperInputComponent
                                    className="w100-percent mr-2"
                                // isRequired={true}
                                // isValidation={true}
                                // dataValidation={data.HMS00000236}
                                // validation={validation.HMS00000236}
                                // labelTitle={t(`item.banner.HMS00000236`)}
                                >
                                    <Input placeholder={t('item.checkVoucher.checkCode')} type={`text`}
                                        className={`form-control`}
                                        name={`serialNumber`} onChange={this.onChange}
                                        value={Func.checkUndefine(data.serialNumber)}
                                    />
                                </HMS.FormWrapperInputComponent>
                                <ANT.Button type="primary" loading={isChecked} disabled={isChecked}
                                    onClick={this.onCheckVoucher}>
                                    {t('item.checkVoucher.title')}
                                </ANT.Button>
                            </div>
                        </form>
                    </ANT.PageHeader>
                    <HMS.WrapperComponent>
                        <HMS.LoadingComponent spinning={isChecked}>
                            {
                                resultCheck ? (
                                    <ANT.Card size="small" title={resultCheck.isLocked ?
                                        <Fragment>
                                            <i className="fa fa-lock mr-2" /> {t('item.checkVoucher.islocked')}
                                        </Fragment> : resultCheck.status === 7 ? t('item.checkVoucher.used') : usedVoucher ? t('item.checkVoucher.used') : t('item.checkVoucher.valid')
                                    }
                                        extra={
                                            <Fragment>
                                                { 
                                                    orderPermisionActions && orderPermisionActions.allowView && 
                                                    <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: this.state.resultCheck.orderId })} className={`mr-2`}>
                                                        <button className="btn btn-primary">{t('item.checkVoucher.goToOrder')}</button>
                                                    </Link>
                                                }
                                                {
                                                    voucherPermisionActions && voucherPermisionActions.allowUpdate &&
                                                    <button
                                                        className={`btn ${resultCheck.isLocked ? 'btn-primary' : 'btn-danger'} mr-2`}
                                                        onClick={() => this.onViewItem()}
                                                        disabled={(usedVoucher && compareUsed) || (resultCheck.status === 7 && compareUsed)}>
                                                        {resultCheck.isLocked ? t('item.checkVoucher.unlockvoucher') : t('item.checkVoucher.lockvoucher')}
                                                    </button>
                                                }
                                                {
                                                    permisionActions && permisionActions.allowUseVoucher &&
                                                    <button className="btn btn-success"
                                                        disabled={(usedVoucher && compareUsed) || (resultCheck.status === 7 && compareUsed) || (resultCheck.isLocked || isDisableUse) || (serialNumberState.trim() === resultCheck.checkCode) || (propertyList.length < 1) || this.statusDisabled(resultCheck)}
                                                        onClick={() => this.onShowPopupUse()}> {((usedVoucher && compareUsed) || (resultCheck.status === 7 && compareUsed)) ? t('item.checkVoucher.used') : t('item.checkVoucher.use')}  </button>
                                                }
                                            </Fragment>
                                        }
                                        style={{ width: '100%' }}
                                        headStyle={{
                                            backgroundColor: `${resultCheck.isLocked ? '#f5222d' : (resultCheck.status === 7 || usedVoucher) ? '#f8ac59' : '#084F8C'}`,
                                            color: 'white'
                                        }}
                                    >
                                        {
                                            resultCheck.voucherIssue && (
                                                <Fragment>
                                                    <h4 style={{ color: '#ed5565', textAlign: 'center' }}>
                                                        {resultCheck.voucherIssue && t(`validation.statusCode.code.${resultCheck.voucherIssue}`)}
                                                    </h4>
                                                </Fragment>
                                            )
                                        }
                                        {
                                            (serialNumberState.trim() === resultCheck.checkCode) && this.statusDisabled(resultCheck) && (
                                                <Fragment>
                                                    <h4 style={{ color: '#ed5565', textAlign: 'center' }}>
                                                        {t(`item.checkVoucher.onlycheck`)}
                                                    </h4>
                                                </Fragment>
                                            )
                                        }
                                        {
                                            (propertyList.length < 1) && (
                                                <Fragment>
                                                    <h4 style={{ color: '#ed5565', textAlign: 'center' }}>
                                                        {t(`validation.statusCode.code.11010`)}
                                                    </h4>
                                                </Fragment>
                                            )
                                        }
                                        {/*{HMSCode && <Fragment>*/}
                                        {/*<h4 style={{*/}
                                        {/*color: "red",*/}
                                        {/*textAlign: "center",*/}
                                        {/*width: '100%'*/}
                                        {/*}}>{t('item.checkVoucher.hmscode')}: {HMSCode}</h4>*/}
                                        {/*</Fragment>}*/}
                                        <div className="row mt-3">
                                            <div className="col-md-4">
                                                <ANT.Card type="inner" title={t('item.checkVoucher.infoVoucher')}>
                                                    <p>
                                                        <b>{t('item.checkVoucher.use')}</b>:
                                                        ({(resultCheck.usedCount) + usedCount}/{resultCheck.limitNumberOfTimes} {t('item.checkVoucher.times')})
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.startdate')}</b>: {resultCheck.startDate && `${moment(resultCheck.startDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.enddate')}</b>: {resultCheck.endDate && `${moment(resultCheck.endDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.price')}</b>: {resultCheck.price && Func.formatMoney(resultCheck.price)}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.orderCode')}</b>: {resultCheck.orderCode && resultCheck.orderCode}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.bookingDate')}</b>: {resultCheck.bookingDate && `${moment(resultCheck.bookingDate).format(DATE_TIME_FORMAT.DATE_TIME)}`}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.price')}</b>: {resultCheck.price && Func.formatMoney(resultCheck.price)}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.fullname')}</b>: {resultCheck.fullname ? resultCheck.fullname : getLocaleFullName(resultCheck.firstName, resultCheck.lastName)}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.email')}</b>: {resultCheck.email && resultCheck.email}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.phone')}</b>: {resultCheck.phoneNumber && resultCheck.phoneNumber}
                                                    </p>
                                                </ANT.Card>
                                                {compareUsed && <ANT.Card className="mt-4" type="inner" title={t('item.checkVoucher.infoUsed')}>
                                                    <p>
                                                        <b>{t('item.checkVoucher.checkedDate')}</b>: {resultCheck.checkedDate && `${moment(resultCheck.checkedDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.checkInDate')}</b>: {resultCheck.checkInDate && `${moment(resultCheck.checkInDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.checkOutDate')}</b>: {resultCheck.checkOutDate && `${moment(resultCheck.checkOutDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.operaBookingCode')}</b>: {resultCheck.operaBookingCode && resultCheck.operaBookingCode}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.propertyOfStay')}</b>: {resultCheck.propertyOfStay && resultCheck.propertyOfStay.name}
                                                    </p>
                                                </ANT.Card>}
                                            </div>
                                            <div className="col-md-4">
                                                <ANT.Card type="inner" title={t('item.checkVoucher.infoGroup')}>
                                                    <p>
                                                        <b>{t('item.checkVoucher.groupname')}</b>: {resultCheck.groupName && resultCheck.groupName}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.saleStartDate')}</b>: {resultCheck.saleStartDate && `${moment(resultCheck.saleStartDate).format('DD-MM-YYYY HH:mm:ss')}`}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.saleEndDate')}</b>: {resultCheck.saleEndDate && `${moment(resultCheck.saleEndDate).format('DD-MM-YYYY HH:mm:ss')}`}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.originalPrice')}</b>: {resultCheck.originalPrice && Func.formatMoney(resultCheck.originalPrice)}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.salePrice')}</b>: {resultCheck.salePrice && Func.formatMoney(resultCheck.salePrice)}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.properties')}</b>:
                                                        {
                                                            resultCheck.properties && resultCheck.properties.map((p, k) => {
                                                                return (
                                                                    <span style={{ marginBottom: 0, display: 'block' }}
                                                                        key={k}>- {p.name}</span>
                                                                )
                                                            })
                                                        }
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.products')}</b>: {resultCheck.products && resultCheck.products.join(', ')}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.minOrderValue')}</b>: {resultCheck.minOrderValue && Func.formatMoney(resultCheck.minOrderValue)}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.maxOrderValue')}</b>: {resultCheck.maxOrderValue && Func.formatMoney(resultCheck.maxOrderValue)}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.maxDiscountValue')}</b>: {resultCheck.maxDiscountValue && Func.formatMoney(resultCheck.maxDiscountValue)}
                                                    </p>
                                                    <p>
                                                        <b>{t('item.checkVoucher.voucherType')}</b>: {resultCheck.voucherType && discountVal}
                                                    </p>
                                                </ANT.Card>
                                            </div>
                                            <div className="col-md-4">
                                                <ANT.Card className="mb-4" type="inner" title={t('item.group.operationManuals')}>
                                                    <pre className={`result_name`}
                                                        dangerouslySetInnerHTML={{ __html: xssFilter(resultCheck.operationManuals && resultCheck.operationManuals) }}
                                                        style={{ height: '30vh', overflowY: 'scroll' }} />
                                                </ANT.Card>
                                                <ANT.Card type="inner" title={t('item.checkVoucher.conditionOfUse')}>
                                                    <pre className={`result_name`}
                                                        dangerouslySetInnerHTML={{ __html: xssFilter(resultCheck.conditionOfUse && resultCheck.conditionOfUse) }}
                                                        style={{ height: '30vh', overflowY: 'scroll' }} />
                                                </ANT.Card>
                                            </div>
                                        </div>
                                    </ANT.Card>
                                ) : (
                                        <ANT.Empty image={ANT.Empty.PRESENTED_IMAGE_SIMPLE}
                                            description={
                                                message ? <span
                                                    className="colorRed">{message}</span> : t('item.checkVoucher.checkCode')
                                            } />
                                    )
                            }
                        </HMS.LoadingComponent>
                    </HMS.WrapperComponent>
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        vouchers: state.voucherReducer,
        profile: state.authReducer,
        property: state.propertyReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListAllProperties: () => {
            dispatch(action.dataAllPropertyAction())
        },
        onCheckVoucher: (filters) => {
            dispatch(action.checkVoucherAction(filters))
        },
        onUsedVoucher: (filters) => {
            dispatch(action.usedVoucherAction(filters))
        },
        onUpdateVoucher: (params) => {
            dispatch(action.updateVoucherAction(params))
        },
        onResetCheck: () => {
            dispatch(action.voucherReset())
        },
        // onListVoucher: (filters) => {
        //     dispatch(action.dataVoucherAction(filters))
        // },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Index));
